import { prefixerM } from '.'

export const ROUTE_ENTIDADES_ORGANIZACIONALES = prefixerM('entidades-organizacionales')
export const ROUTE_ESTADO_PLAN_CUENTA = prefixerM('estado-plan-cuenta')
export const ROUTE_PLAN_DE_CUENTAS = prefixerM('plan-de-cuentas')
export const ROUTE_GESTION_CC_SS = prefixerM('gestion-cc-ss')
export const ROUTE_GESTION_MODULO_PROCESO_SUBPROCESO = prefixerM('gestion-modulo-proceso-subproceso')
export const ROUTE_MAESTRO_CLASE_CUENTA = prefixerM('maestro-clase-cuenta')
